import { cn } from "@/utils/utils";

export default function Wave({ className }: { className?: string }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1440 380"
            className={cn("w-screen", className)}
        >
            <path
                d="M0,160 C480,80 960,240 1440,160 L1440,420 L0,380 Z"
            />
        </svg>
    );
}
